import { render, staticRenderFns } from "./CRMListHead.vue?vue&type=template&id=12a29980&scoped=true&"
import script from "./CRMListHead.vue?vue&type=script&lang=js&"
export * from "./CRMListHead.vue?vue&type=script&lang=js&"
import style0 from "./CRMListHead.vue?vue&type=style&index=0&id=12a29980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a29980",
  null
  
)

export default component.exports